<div
  class="flex flex-col h-full relative w-72"
  [class.max-lg:hidden]="!showSidebar()"
  [class.max-sm:w-screen]="showSidebar()">

  <button
    mat-icon-button
    class="cursor-pointer hover:text-primary m-4 !absolute top-0 right-0 !z-50 lg:!hidden"
    (click)="showSidebarChange.emit(false)">
    <mat-icon color="primary">close</mat-icon>
  </button>

  <div class="px-4 w-full relative h-32 mt-8 z-0">
    <div class="flex justify-center">
      <img
        ngSrc="assets/images/roadit-logo-square.png"
        class="rounded-[50%] mb-1 !w-32 !relative cursor-pointer"
        (click)="navigateToHome()"
        (keydown.enter)="navigateToHome()"
        tabindex="0"
        role="button"
        alt="Road IT Logo"
        fill="true"
        priority="true" />
    </div>
  </div>

  <app-sidebar-menu [sidebarMenuItems]="sidebarMenuItems"></app-sidebar-menu>

  <div
    class="absolute bottom-0 w-full flex flex-col pb-4 pt-10 px-4
           text-ellipsis whitespace-nowrap overflow-x-hidden
           bg-gradient-to-t from-white from-80%">

    <div class="flex flex-col mb-5 text-center">
      <span class="font-medium">{{ username() }}</span>
      <span class="text-gray text-base">{{ formattedRoles() }}</span>
    </div>

    <button mat-raised-button color="primary" type="button" (click)="logout()">
      <mat-icon class="text-white mr-2">logout</mat-icon>
      <span class="text-white transition-all duration-300">Abmelden</span>
    </button>

    <div class="pt-2 text-primary text-[14px] !min-w-12 transition-all flex justify-center">
      <a [routerLink]="['/impressum']" class="underline pr-1" title="Impressum">Impressum</a>
      |
      <a [routerLink]="['/datenschutzerklaerung']" class="underline pl-1" title="Datenschutzerklärung">
        Datenschutzerklärung
      </a>
    </div>
  </div>
</div>
